module.exports = __webpack_public_path__ + "static/media/con3.11ee624c.jpeg";